import React, { useState } from "react";
import PropTypes from 'prop-types';

const TextForm = (props) => {
    // to use state
    const [text, setText] = useState("");
    // text = "new Text" // Wrong way to change State
    // setText(new Text) // Correct way to change State
    // set text is a function

    const handleOnChange = (event) => {
        setText(event.target.value)
    }

    const handleClickToUpper = () => {
        let newText = text.toUpperCase()
        setText(newText)
        text.length > 0 ? props.showAlert('success', 'Converted to Uppercase') : props.setAlert(null)
    }

    const handleClickToLower = () => {
        let newText = text.toLowerCase()
        setText(newText)
        text.length > 0 ? props.showAlert('success', 'Converted to LowerCase') : props.setAlert(null)
    }

    const handleClear = () => {
        let newText = ""
        setText(newText)
        text.length > 0 ? props.showAlert('success', 'Text Cleared') : props.setAlert(null)
    }
    // Exercise solutions
    const copyText = () => {
        // let text = document.querySelector('#textBox')
        // text.select();
        navigator.clipboard.writeText(text)
        // document.getSelection().removeAllRanges()
        text.length > 0 ? props.showAlert('success', 'Text Copied to Clipboard') : props.setAlert(null);
    }

    const removeExtraSpaces = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "))
        text.length > 0 ? props.showAlert('success', 'Removed Extra Spaces') : props.setAlert(null)
    }

    return (
        <>
            <div className="container flex flex-col">
                <h1>{props.heading}</h1>
                <label htmlFor="textBox" className="w-100">
                    <textarea
                        name="textBox"
                        onChange={handleOnChange}
                        value={text}
                        id="textBox"
                        rows="8"
                        className="form-control w-100 my-3"
                        aria-label="Input Your Text Here"
                        aria-describedby="addon-wrapping"
                    ></textarea>
                </label>
                <button type="button"
                    className={`btn btn-primary rounded m-2`}
                    onClick={handleClickToUpper}
                >
                    Convert to UPPERCASE
                </button>
                {/* Solution buttons */}
                <button type="button"
                    className={`btn btn-primary rounded m-2`}
                    onClick={handleClickToLower}
                >
                    Convert to lowercase
                </button>
                <button type="button"
                    className={`btn btn-primary rounded m-2`}
                    onClick={removeExtraSpaces}
                >
                    Remove Extra spaces
                </button>
                <button type="button"
                    className={`btn btn-primary rounded m-2`}
                    onClick={copyText}
                >
                    Copy Text
                </button>
                
                <button type="button"
                    className={`btn btn-primary rounded m-2`}
                    onClick={handleClear}
                >
                    Clear
                </button>
            </div>
            <div className="container mt-4">
                <h2>Your text Summary</h2>
                <p>You have written {text.length === 0 ? 0 : text.split(/\s+/).filter((element)=> element.length !== 0).length} words and {text.length} characters including spaces.</p>
                <p>{text.length === 0 ? 0 : 0.008 * text.split(" ").length} minutes read.</p>
                <h2>Preview</h2>
                <div className="preview container-fluid">
                    <p>{text.length > 0 ? text : "Enter some text above to Preview"}</p>
                </div>
            </div>
        </>
    );
};

TextForm.propTypes = {
    heading: PropTypes.string.isRequired
}

export default TextForm;
